<template>
	<b-modal
		id="import-everything-dialog"
		:modal-class="theme"
		ref="gitImportEverythingModal"
		size="xl"
		title="Import Everything"
		no-close-on-backdrop
		hide-footer
	>
		<ImportEverything  ref="gitImportEverything"  v-if="results" :results="results" v-bind:git="git" />
		<ErrorAlert v-if="error" :error="error" />
		<div class="form-group text-right mt-5 mb-0">
			<button class="btn btn-primary" type="button" :disabled="loading" @click="submit(true)">
				<span
					v-if="loading"
					class="spinner-border spinner-border-sm mr-2"
					role="status"
					aria-hidden="true"
				></span>
				Submit
			</button>
			<button class="btn btn-secondary" type="button" @click="close()">
				Close
			</button>
		</div>		
	</b-modal>
	
</template>

<script>
import GitConfig from '../../services/git-config';
import ImportEverything from "./ImportEverything";
import ThemeService from '../../services/theme';
import ErrorAlert from "../shared/ErrorAlert";

export default {
	name: "ImportEverythingDialog",
	components: {
		ImportEverything,
		ErrorAlert
	},
	props: {
		results: Array
	},
	data() {
		return {
			git : {},
			error: null,
			
			loading: false
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.backupKey = (Math.random() + 1).toString(36).substring(7); 
		this.listenForThemeChanges();
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {		
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
		open(git) {
			this.timer = setInterval(() => {
				// this.submit(false)
			}, 120000)
			this.git = git;
			this.$refs.gitImportEverythingModal.show();
		},
		close() {	
			clearInterval(this.timer);
			this.$refs.gitImportEverythingModal.hide();	
		},
		submit(sendImportRequests) {
			if (sendImportRequests) {
				this.loading = true;
			}
			var sendGit = JSON.parse(JSON.stringify(this.git));
			sendGit.confirmed = [];
			sendGit.progress = JSON.parse(JSON.stringify(this.results));
			this.results.forEach(element => {
				var elCopy = JSON.parse(JSON.stringify(element))
				Object.assign(elCopy, element);
				for (var collectionName in elCopy.sendBody) {
					if(!elCopy.sendBody[collectionName]){
						continue;
					}
					if(elCopy.sendBody[collectionName] && collectionName == "localAndGitDiff"){
						delete elCopy.sendBody["localAndGitDiff"];
						continue;
					}
					elCopy.sendBody[collectionName] = elCopy.sendBody[collectionName].filter(
						element => element && element.markedForDeletion != true
					);
					elCopy.sendBody[collectionName].forEach(e => {
						e.localAndGitDiff = null;
						if (e.uiFolderName) {
							e.name = e.uiFolderName;
						}
						if (e.configDisabled) {
							e.disabled = e.configDisabled;
						}
					});
				}
				elCopy.gitBody = JSON.stringify(elCopy.sendBody);
				elCopy.localBody = null;
				sendGit.confirmed.push(elCopy);
			});
			sendGit.sendImportRequests = sendImportRequests;
			sendGit.backupKey = this.backupKey;
			if (sendImportRequests) {
				clearInterval(this.timer);
			}
			GitConfig.instance().setGitConfigConfirm(sendGit)
				.then(() => {
					if (sendImportRequests) {
						this.loading = false;
						this.$refs.gitImportEverythingModal.hide();	
					}
			}).catch((err) => {
				this.loading = false;
				this.errMsg = null;
				this.error = err;
			});
		}
	}
};
</script>

<style scoped>

</style>